window.trackerEvents = new Vue();